<template>
  <div style="top: -19px;position: relative; display: flex;flex-direction: column; justify-content: space-between; align-items: center;">
    <div style="width: 100vw; height: 70px; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; max-width: 1920px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;'">
      <div style="width: 15%; min-width: 80px; text-align: left;">
        <router-link to="/"><img src="https://etacdn.b-cdn.net/eta-new-logo.png" alt="easytailorapp" style="width: 75px; top: 4px; position: relative;"></router-link>
      </div>
    
      <div v-if="$store.getters.getScreenWidth>=700" style="width: 60%; display: flex; flex-direction: row; justify-content: center; align-items: center;">
        <router-link 
          v-for="(data, index) in getMenuList" 
          :key="index" :to="data.path" 
          style="text-decoration: none; color: black; margin-right: 40px; font-size: 16px;">{{data.label}}</router-link>
      </div>
      <div v-if="$store.getters.getScreenWidth>=700" style="width: 25%; display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
        <a href="https://cloud.easytailorapp.com" 
        style="text-decoration: none; color: black; margin-right: 20px; font-size: 16px;">Login</a>
       <a
          href="javascript:void(0)"
          @click="toggleSignup"
          style="color: #ffffff !important; padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 5px; background-color: #a2a2a2; border-radius: 10px; text-decoration: none; font-size: 16px;">Try it for free</a>
      </div>
      <img 
        @click="$store.state.master.menu_toggle = !$store.state.master.menu_toggle"
        v-if="$store.getters.getScreenWidth<700" 
        :src="isMenuToggled ? 'https://etacdn.b-cdn.net/new-website/xmark-solid.svg' : 'https://etacdn.b-cdn.net/new-website/bars-solid.svg'" 
        style="width: 30px"
        alt="">
      <div v-if="isMenuToggled" :style="'opacity: 0.8; z-index: 1; width: 200px; position: fixed; left: '+($store.getters.getScreenWidth-240)+'px; right: 0; top: 20px; height: 400px; background-color: #000; color: white; padding: 0;'">
          <div style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <router-link 
              v-for="(data, index) in getMenuList" 
              :key="index" :to="data.path" 
              style="margin: 20px; text-decoration: none; color: black; font-size: 16px; color: white;">{{data.label}}</router-link>
            
            <a href="https://cloud.easytailorapp.com" 
            style="text-decoration: none; color: black; font-size: 16px; margin: 20px; color: white;">Login</a>
            <!--<a 
              href="javascript:void(0)"
              @click="toggleSignup"
              style="margin: 20px; color: #ffffff !important; padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 5px; background-color: #a2a2a2; border-radius: 10px; text-decoration: none; font-size: 16px;">Try it for free</a>-->
              
          </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
      return {
        toggle_singup: false
      }
  },
  computed: {
    isMenuToggled() {
        return this.$store.state.master.menu_toggle
    },
    getMenuList() {
      return [
        {label: 'Home', path: '/'},
        {label: 'Features', path: '/features'},
        {label: 'Demo', path: '/screenshots'},
        {label: 'Pricing', path: '/pricing'},
        //{label: 'Download', path: '/apps'}
      ]
    }
  },
  methods: {
    toggleSignup() {
      this.$emit('toggleSignup')
      this.menu_toggle = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Header/Index.vue